import { userContext } from '../userManager';

export const apiTotalWealthProfileSimulation = ({
  initialInvestment,
  investmentPeriod,
  monthlySalary,
  monthlyOtherIncome,
  otherAssets,
  otherFinancialInvestments,
  monthlyCostOfLiving,
  monthlyFixedExpenses,
  mortgage,
  otherLiabilities,
  strategyReturn,
  strategyVolatility,
  averageYearlyInvestment,
}) =>
  userContext.apiCall({
    url: '/total-wealth/profile-simulations',
    method: 'POST',
    body: {
      initialInvestment,
      investmentPeriod,
      monthlySalary,
      monthlyOtherIncome,
      otherAssets,
      otherFinancialInvestments,
      monthlyCostOfLiving,
      monthlyFixedExpenses,
      mortgage,
      otherLiabilities,
      strategyReturn,
      strategyVolatility,
      averageYearlyInvestment,
    },
  });

export const apiRiskProfiles = ({
  riskAversenessLevel,
  volSensibilityLevel,
  lossesSensibilityLevel,
  investmentPeriod,
  tradedInstruments,
  lastInvestmentDuration,
  lastInvestmentAmount,
  currentTotalWealthAmount,
  netCash,
}) =>
  userContext.apiCall({
    url: '/risk-profiles',
    method: 'GET',
    qs: {
      investmentPeriod,
      riskAversenessLevel,
      volSensibilityLevel,
      lossesSensibilityLevel,
      tradedInstruments,
      lastInvestmentDuration,
      lastInvestmentAmount,
      currentTotalWealthAmount,
      netCash,
    },
  });

export const apiClientFinancialAdvisorsGet = (clientId) =>
  userContext.apiCall({
    url: `/clients/${clientId}/financialadvisors`,
    method: 'GET',
  });

export const apiClientDetailsPatch = (clientId, { allowFaOnboarding }) =>
  userContext.apiCall({
    url: `/clients/${clientId}/details`,
    method: 'PATCH',
    body: {
      allowFaOnboarding,
    },
  });

export const apiClientAssetsBreakdownGet = (clientId, types, relationshipType) => {
  let url = `/clients/${clientId}/assets-breakdown?types=${types}`;
  if (relationshipType) {
    url += `&relationshipType=${relationshipType}`;
  }
  return userContext.apiCall({
    url,
  });
};
